/** Reasons offered when reporting a quest. The API still accepts any short code. */
export const REPORT_REASONS = ["spam", "unsafe", "copyright", "other"] as const;
export type ReportReason = (typeof REPORT_REASONS)[number];
